//  a file to keep track of all our custom elements. 

class LandingSearchElement extends HTMLDivElement {
    constructor() { super(); }
}

class EventFilterElement extends HTMLUListElement {
    constructor() { super(); }
}

class EventsContainerElement extends HTMLDivElement {
    constructor() { super(); }
}

class NewsContainerElement extends HTMLDivElement {
    constructor() { super(); }
}

class SCustomElements {
    public static async events() {
        await customElements.define('events-container', EventsContainerElement, { 
            extends: 'div' 
        });
        await customElements.define('event-filters', EventFilterElement, {
            extends: 'ul' 
        });
    }
    public static async news() {
        await customElements.define('news-container', NewsContainerElement, {
            extends: 'div' 
        });
    }
    public static async landingSearch() {
        await customElements.define("landing-search", LandingSearchElement, {
            extends: "div",
        });
    }
}

export default SCustomElements;
export { LandingSearchElement, EventFilterElement, EventsContainerElement, NewsContainerElement };